export default __webpack_public_path__ + "static/media/poppins-regular.35d26b78.ttf";